import { render, staticRenderFns } from "./SelectCategory.vue?vue&type=template&id=c9c30850"
import script from "./SelectCategory.vue?vue&type=script&lang=js"
export * from "./SelectCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9c30850')) {
      api.createRecord('c9c30850', component.options)
    } else {
      api.reload('c9c30850', component.options)
    }
    module.hot.accept("./SelectCategory.vue?vue&type=template&id=c9c30850", function () {
      api.rerender('c9c30850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/management/ticket/pages/category/SelectCategory.vue"
export default component.exports